import { Fragment } from 'react'
import Spinner from '../Spinner'
import { Combobox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { RxCross1 } from 'react-icons/rx'
import { pageModel } from '../../utils/model'

const SearchPicker = (props) => {

    const { label, label2, pendingApiCall, state, setState, query = "", setQuery, error, setErrors, onClickClear, page = pageModel, onClickLoadMore, option, value, className, disabled } = props

    console.log(className)

    return (
        <div className={`w-full mb-3 col-span-3 ${className}`}>
            <div className='flex items-center justify-between'>
                <span className='flex items-center'>
                    <div className='flex gap-x-1 items-center'>
                        <label>{label} </label>
                        {
                            label2 &&
                            <label className='text-xs'>({label2}) </label>
                        }

                    </div>

                    {pendingApiCall && <Spinner />}
                </span>
                {
                    (state && onClickClear && !disabled) &&
                    <span onClick={onClickClear}>
                        <RxCross1 />
                    </span>
                }
            </div>
            <Combobox
                value={value}
                disabled={disabled}
                onChange={(value) => {
                    setState(value)
                    setErrors && setErrors()
                }}
            >
                <div className="relative mt-1">
                    <div className="relative w-full cursor-default overflow-hidden rounded-md bg-white text-left shadow-md">
                        <Combobox.Input
                            placeholder='Arama yapın...'
                            className="w-full border rounded-md py-2 pl-3 pr-10 text-xs leading-5 text-gray-900 outline-none"
                            displayValue={state?.code}
                            onChange={(event) => setQuery(event.target.value)}
                        />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon
                                className="h-5 w-5 text-gray-600"
                            />
                        </Combobox.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        afterLeave={() => setQuery('')}
                    >
                        <Combobox.Options className="z-50 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 text-xs">
                            {page?.content?.length === 0 && query !== '' ? (
                                <div className="relative cursor-default px-4 py-2 text-gray-700">
                                    Kayıt bulunamadı.
                                </div>
                            ) : (
                                page.content?.map((account) => (
                                    <Combobox.Option
                                        key={account.id}
                                        className={({ active }) =>
                                            `relative cursor-pointer border-b border-b py-2 pl-4 pr-4 ${active ? 'bg-purple-700 text-white' : 'text-gray-900'
                                            }`
                                        }
                                        value={account}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span
                                                    className={`block ${selected ? 'font-medium' : 'font-normal'
                                                        }`}
                                                >
                                                    {option(account)}
                                                </span>
                                                {selected ? (
                                                    <span
                                                        className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                                                            }`}
                                                    >

                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Combobox.Option>
                                ))
                            )}
                            {
                                page?.last
                                    ? <Combobox.Option className='relative cursor-default py-2 pl-4 pr-4 text-xs font-regular italic'>Tüm kayıtlara ulaştınız</Combobox.Option>
                                    :
                                    <Combobox.Option
                                        onClick={e => {
                                            onClickLoadMore()
                                            e.preventDefault()
                                        }}

                                        className={({ active }) =>
                                            `relative cursor-default py-2 pl-4 pr-4 ${active ? 'bg-[#0061FD] text-white' : 'text-gray-900'
                                            }`
                                        }

                                    >
                                        Daha fazla yükle
                                    </Combobox.Option>
                            }
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
            {error && <label className='text-red-700'>{error} </label>}
        </div>
    )
}

export default SearchPicker